import type { AxiosInstance } from 'axios'
import type { IFactoryFunctionRequest } from '@bc-library/interface'
import { EMethod } from '@bc-library/interface'
import { API_MAIN_VERSION, BASE_URL } from '@/config/constantes'
import useAxios from '@/services/api/useAxios'

const resource = 'projectStatus'

const getAll = (axios: IFactoryFunctionRequest<Array<any>, undefined>) => () => {
  return axios({
    method: EMethod.get,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/firm`,
  })
}

const paginate = (axios: IFactoryFunctionRequest<Array<any>, undefined>) => ({
  page = 0,
  search = '',
  limit = 30,
}: { page?: number; search?: string; limit?: number }) => {
  return axios({
    method: EMethod.get,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/v2/filter`,
    query: { page, search, limit },
  })
}

const getOne = (axios: IFactoryFunctionRequest<any, any>) => (id: string) => {
  return axios({
    method: EMethod.get,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/v2/${id}`,
  })
}

const create = (axios: IFactoryFunctionRequest<any, any>) => (data: any) => {
  return axios({
    method: EMethod.post,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/v2`,
    data,
  })
}

const update = (axios: IFactoryFunctionRequest<any, any>) => (id: string, { data }: { data: any }) => {
  return axios({
    method: EMethod.put,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/v2/${id}`,
    data,
  })
}

const deleteStatus = (axios: IFactoryFunctionRequest<any, any>) => (id: string) => {
  return axios({
    method: EMethod.delete,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/v2/${id}`,
  })
}

export default (axios: AxiosInstance) => ({
  getAll: getAll(useAxios(axios)),
  paginate: paginate(useAxios(axios)),
  getOne: getOne(useAxios(axios)),
  create: create(useAxios(axios)),
  update: update(useAxios(axios)),
  delete: deleteStatus(useAxios(axios)),
})
